import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRainyLight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRainyLight"><Path d="M3 9.5C3 5.91015 5.91015 3 9.5 3C11.8418 3 13.8927 4.2383 15.0364 6.09297C15.3486 6.03193 15.6709 6 16 6C18.7614 6 21 8.23858 21 11C21 13.7614 18.7614 16 16 16H11.3698L9.94901 18.8415L8.16016 17.9471L9.13862 15.9901C5.71686 15.8026 3 12.9686 3 9.5Z" fill="currentColor"/><Path d="M12.949 21.8415L14.8434 18.0526L13.0546 17.1582L11.1602 20.9471L12.949 21.8415Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRainyLight;
